import { useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { motion, AnimatePresence } from 'framer-motion';
import IntegrationsTab from './tabs/IntegrationsTab';
import TaxSettingsTab from './tabs/TaxSettingsTab';
import NotificationsTab from './tabs/NotificationsTab';
import PoliciesTab from './tabs/PoliciesTab';
import BillingTab from './tabs/BillingTab';
import DiscountTab from './tabs/DiscountTab';
import FeatureTab from './tabs/FeatureTab';
import ScriptTab from './tabs/ScriptTab';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('integrations');

  const tabs = [
    { id: 'integrations', label: 'Integrations' },
    { id: 'tax-settings', label: 'Tax settings' },
    { id: 'notifications', label: 'Notifications' },
    { id: 'policies', label: 'Policies' },
    { id: 'billing', label: 'Billing and Invoice Management' },
    { id: 'discount', label: 'Discount code settings' },
    { id: 'feature', label: 'Feature configuration' },
    { id: 'script', label: 'Script Automation' },
  ];

  return (
    <div className="px-6 pb-3 overflow-hidden overflow-y-auto h-full relative">
      <div className="pt-6">
        <h1 className="text-xl font-semibold text-white mb-6">Settings</h1>
        
        <Tabs.Root value={activeTab} onValueChange={setActiveTab}>
          <div className="sticky top-0 pt-4 bg-[#232323] z-20">
            <Tabs.List className="flex space-x-1 bg-[#2A2A2A] rounded-lg p-1">
              {tabs.map((tab) => (
                <Tabs.Trigger
                  key={tab.id}
                  value={tab.id}
                  className={`px-4 py-2 text-sm transition-colors rounded-md flex-1 ${
                    activeTab === tab.id
                      ? 'bg-gradient-to-r from-[#65f4cdcc] to-[#4799e9b3] text-white'
                      : 'text-gray-400 hover:text-white hover:bg-[#3a3a3a33]'
                  }`}
                >
                  {tab.label}
                </Tabs.Trigger>
              ))}
            </Tabs.List>
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="mt-6"
            >
              <Tabs.Content value="integrations">
                <IntegrationsTab />
              </Tabs.Content>

              <Tabs.Content value="tax-settings">
                <TaxSettingsTab />
              </Tabs.Content>

              <Tabs.Content value="notifications">
              <NotificationsTab/>
              </Tabs.Content>

              <Tabs.Content value="policies">
                <PoliciesTab />
              </Tabs.Content>

              <Tabs.Content value="billing">
                <BillingTab />
              </Tabs.Content>

              <Tabs.Content value="discount">
                <DiscountTab/>
              </Tabs.Content>

              <Tabs.Content value="feature">
               <FeatureTab/>
              </Tabs.Content>

              <Tabs.Content value="script">
                <ScriptTab/>
              </Tabs.Content>
            </motion.div>
          </AnimatePresence>
        </Tabs.Root>
      </div>
    </div>
  );
} 